<template>
  <div>
    <el-input
      style="width: 200px"
      v-model="search.code"
      placeholder="預約單號"
      size="small"
      class="search-condition"
    ></el-input>
    <el-select
      v-model="search.type"
      size="small"
      style="width: 100px; margin-right: 20px"
      placeholder="預約類型"
      clearable
    >
      <el-option label="訪客" :value="'1'" />
      <el-option label="學生" :value="'2'" />
    </el-select>

    <el-input
      style="width: 200px"
      v-model="search.tel"
      placeholder="聯繫電話"
      size="small"
      class="search-condition"
    ></el-input>
    <el-input
      style="width: 200px"
      v-model="search.name"
      placeholder="聯繫人"
      size="small"
      class="search-condition"
    ></el-input>
    <el-input
      style="width: 200px"
      v-model="search.company"
      placeholder="公司"
      size="small"
      class="search-condition"
    ></el-input>
    <el-row style="margin-top: 10px">
      <el-date-picker
        v-model="search.arrivalDate"
        size="small"
        type="daterange"
        :clearable="false"
        range-separator="至"
        start-placeholder="入住日期查詢起"
        end-placeholder="入住日期查詢止"
        class="search-condition"
      >
      </el-date-picker>
      <el-date-picker
        v-model="search.departureDate"
        size="small"
        type="daterange"
        :clearable="false"
        range-separator="至"
        start-placeholder="退宿日期查詢起"
        end-placeholder="退宿日期查詢止"
        class="search-condition"
      >
      </el-date-picker>
      <el-button type="primary" @click="reset" size="small">重置</el-button>
      <el-button
        type="success"
        @click="getList"
        size="small"
        icon="el-icon-search"
        >查詢</el-button
      >
    </el-row>
    <el-table
      stripe
      :data="tableData"
      style="width: 100%; color: black; margin-top: 20px"
      ref="multipleTable"
      height="620"
      @sort-change="sortChange"
    >
      <el-table-column align="left" :label="$t('app.operation')" width="300">
        <template slot-scope="scope">
          <el-button type="primary" @click="detail(scope.row)" size="small"
            >詳情</el-button
          >
          <el-button
            type="success"
            @click="alloc(scope.row)"
            size="small"
            :disabled="scope.row.type == '學生'"
            >分配</el-button
          >
          <el-button type="warning" @click="finance(scope.row)" size="small"
            >賬務</el-button
          >
        </template>
      </el-table-column>
      <el-table-column
        align="center"
        label="預約編號"
        prop="code"
        width="250"
      />
      <el-table-column
        align="center"
        label="預約類型"
        prop="type"
        width="120"
      />
      <el-table-column align="center" label="聯繫人" prop="name" width="200" />
      <el-table-column align="center" label="聯繫方式" prop="tel" width="150" />
      <el-table-column align="center" label="公司" prop="company" />
      <el-table-column
        align="center"
        label="入住日期"
        prop="arrival"
        width="150"
        sortable="custom"
      />
      <el-table-column
        align="center"
        label="退宿日期"
        prop="departure"
        width="150"
      >
        <template slot-scope="scope" v-if="scope.row.isNoPaid">
          <div style="color: red; font-weight: bolder">
            {{ scope.row.departure }}
          </div>
        </template>
        <template v-else>
          {{ scope.row.departure }}
        </template>
        <!-- </el-table-column></el-table
    >
  </div>
</template> -->
      </el-table-column>
    </el-table>
    <el-pagination
      style="text-align: center"
      background
      :total="total"
      :current-page.sync="currentPage"
      @size-change="handleSizeChange"
      @current-change="getList"
      :page-sizes="[10, 50, 200, 1000]"
      :page-size="size"
      layout="sizes, total, prev, pager, next"
    >
    </el-pagination>
    <alloc-modal ref="allocModal"></alloc-modal>
    <detail-modal ref="detailModal"></detail-modal>
    <financial-modal ref="financialModal"></financial-modal>
  </div>
</template>
<script>
import AllocModal from "./modules/AllocModal";
import DetailModal from "./modules/DetailModal";
import FinancialModal from "./modules/Financial";
import { getList } from "@/api/guest/list";
import { delEmpty } from "@/utils/utils";
export default {
  components: {
    AllocModal,
    DetailModal,
    FinancialModal,
  },
  data() {
    return {
      search: {
        code: "",
        tel: "",
        name: "",
        company: "",
        arrivalDate: [],
        departureDate: [],
        type: "",
        orderKey: "",
        orderType: "",
      },
      total: 0,
      tableData: [],
      size: 10,
      currentPage: 1,
    };
  },
  created() {
    this.getList();
    // this.getBookingType();
  },
  methods: {
    reset() {
      this.search = {
        code: "",
        tel: "",
        name: "",
        company: "",
        arrivalDate: [],
        departureDate: [],
        type: "",
      };
    },
    finance(row) {
      this.$refs.financialModal.open(row);
    },
    detail(row) {
      this.$refs.detailModal.open(row);
    },
    alloc(row) {
      this.$refs.allocModal.open(row);
    },
    getList() {
      getList(
        delEmpty({
          BookingCode: this.search.code,
          Company: this.search.company,
          ContactPerson: this.search.name,
          ContactTel: this.search.tel,
          ArrivalDateStart: this.search.arrivalDate[0] || "",
          ArrivalDateEnd: this.search.arrivalDate[1] || "",
          DepartureDateStart: this.search.departureDate[0] || "",
          DepartureDateEnd: this.search.departureDate[1] || "",
          PageIndex: this.currentPage,
          PageSize: this.size,
          BookingType: this.search.type,
          OrderKey: this.search.orderKey,
          OrderType: this.search.orderType,
        })
      ).then((res) => {
        this.total = res.data.Total;
        if (res.data.Items === null) {
          this.tableData = [];
        } else {
          this.tableData = res.data.Items.map((_) => {
            return {
              code: _.BookingCode,
              company: _.Company,
              name: _.ContactPerson,
              tel: _.ContactTel,
              arrival: _.ArrivalDate,
              departure: _.DepartureDate,
              type: _.BookingType,
              totalRate: _.TotalRate,
              isNoPaid: _.IsNoPaid,
              rooms: _.BookingRooms
            };
          });
        }
      });
    },
    handleSizeChange(val) {
      this.size = val;
      this.getList();
    },
    tableRowClassName({ row }) {
      if (row.isNoPaid) {
        return "guest-list-warning-row";
      } else {
        return "";
      }
    },
    sortChange(obj) {
      this.search.orderKey = obj.prop;
      this.search.orderType = obj.order;
      this.getList();
    },
  },
};
</script>
<style scoped>
.search-condition {
  margin-right: 0.5rem;
}
</style>
<style>
.el-table .guest-list-warning-row {
  background-color: #ffcc00;
}
</style>
